import React from 'react';

const UploadTheme = {
  headerLogo: {
    src: '/themes/theme/upload/upload-agency.png',
    alt: 'Upload Agency Logo',
    size: 45,
  },
  darkLogo: {
    src: '/themes/theme/upload/upload-agency-wide.png',
    alt: 'Upload Agency Logo',
  },
  headerStyle: {
    backgroundColor: '#fff',
    borderBottom: '2px solid #ef2a30',
    height: 60,
  },
  linkStyle: {
    color: '#000',
    fontWeight: 800,
    fontSize: '120%',
  },
  title: 'Upload Data',
  isLightOnDark: false,
  loginMessage: (
    <div style={{ padding: '10px' }}>
      <br /><br />
      <img
        height="50"
        src="/themes/theme/upload/upload-agency-wide.png" alt="Upload Agency Logo"
      />
      <br /><br />
      <h3>Upload Agency Influencers</h3>
    </div>
  ),
  shareSite: 'https://share.uploadagency.com',
  mediaKit: {
    avatarProps: {
      size: 'small',
      avatar: true,
      floated: 'left',
      style: {
        width: 150,
      },
    },
    logoProps: {
      floated: 'right',
      src: 'https://upload.dyzio.co/themes/theme/upload/upload-logo-wide.png',
      style: {
        width: 400,
        marginTop: 35,
      },
    },
  },
};

export default UploadTheme;



/** WEBPACK FOOTER **
 ** ./src/themes/theme/upload.js
 **/